<p-dialog class="customHeader" [(visible)]="displayOverview" [modal]="true" [responsive]="true" [closable]="true"
    [style]="{ width: '80vw' }" (onHide)="onDialogClose()" appendTo="body">
    <ng-template pTemplate="header">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0">{{ overviewModule }} Overview</h5>
           <div style="display: flex; align-items: center;">
            <p-button *ngIf="selectedInvTransRow?.balanceDue > 0 && overviewModule == transactionNames.Invoice" [label]="'Receive Payments'" (click)="invoiceToReceivePayment()" class="p-mr-2"></p-button>
            <p-button *ngIf="selectedBillTransRow?.balanceDue > 0  && overviewModule == transactionNames.Bill" [label]="'Payment Receipts'" (click)="billToBillPayment()" class="p-mr-2"></p-button>
            <span
                *ngIf="displayOverview && overviewModule == transactionNames.Invoice && invoiceDetails &&  invoiceDetails.invoiceStatusId != 4"
                class="btnBars" (click)="showEditInvoice(overviewModule)">
                <i class="pi pi-pencil"></i>
            </span>
            <span
                *ngIf="poEdit && displayOverview && overviewModule == 'PurchaseOrder' && poDetails && poDetails.purchaseOrderStatusId != 3 && poDetails.purchaseOrderStatusId != 4"
                class="btnBars" (click)="showEditPurchases(overviewModule)">
                <i class="pi pi-pencil"></i>
            </span>
            <span *ngIf="displayOverview && overviewModule == transactionNames.BillPayment" title="Edit BillPayment"
                class="btnBars" (click)="showEditBillPayment()">
                <i class="pi pi-pencil"></i>
            </span>
            <span *ngIf="billDetails" class="btnBars" (click)="isView=false;rpoDetails=null;">
                <i class="pi pi-pencil"></i>
            </span>
            <span *ngIf="rpoDetails" class="btnBars" (click)="isView=false;billDetails=null;">
                <i class="pi pi-pencil"></i>
            </span>
            <span *ngIf="displayOverview && overviewModule == 'Journal Entry' && isView && !isJEVoided"
                title="Edit JournalEntry" class="btnBars" (click)="showEditJournalEntry()">
                <i class="pi pi-pencil"></i>
            </span>
           </div>
        </div>
    </ng-template>
    <div class="header" style="display: flex; justify-content: space-between;">
        <h5> {{overviewModule}}
            <ng-container *ngIf="(!salesOrderDetails || salesOrderDetails?.statusId !== 3)
                && (!invoiceDetails || invoiceDetails?.statusId !== 3)
                && (!estimateDetails || estimateDetails?.statusId !== 3)
                && (!poDetails || poDetails?.statusId !== 3)
                && (!creditMemoDetails || creditMemoDetails?.statusId !== 3)"
                >
                <a class="btnBars p-mr-0 p-ml-2" (click)="navigateToDetails()" *ngIf="displayOverview && overviewModule
                && overviewModule != transactionNames.InventoryAdjustment
                && overviewModule != transactionNames.InventoryTransfer
                && overviewModule != transactionNames.ReceivePayment
                && overviewModule != transactionNames.JournalEntry
                ">
                    <i class="fa fa-external-link"></i>
                </a>
            </ng-container>
        </h5>
    </div>
    <div *ngIf="displayOverview && overviewModule == transactionNames.Invoice">
        <app-invoice-overview [invoicingDetails]="invoiceDetails"
            [visibleFromModule]="'Finance'"></app-invoice-overview>
    </div>
    <div *ngIf="displayOverview && overviewModule == transactionNames.Estimate">
        <app-estimates-overview [estimatesDetails]="estimateDetails"></app-estimates-overview>
    </div>
    <div *ngIf="displayOverview && overviewModule == transactionNames.SalesOrder">
        <app-sales-order-overview [salesOrderDetails]="salesOrderDetails"
            [visibleFromModule]="'Finance'"></app-sales-order-overview>
    </div>
    <div *ngIf="displayOverview && overviewModule == transactionNames.CreditMemo">
        <app-credit-memo-overview [creditMemoDetails]="creditMemoDetails"></app-credit-memo-overview>
    </div>
    <div *ngIf="displayOverview && overviewModule == transactionNames.PurchaseOrder">
        <app-purchase-order-overview [poDetails]="poDetails" [visibleFromModule]="visibleFromModule"></app-purchase-order-overview>
    </div>
    <div *ngIf="displayOverview && overviewModule == transactionNames.CustomerRMA">
        <app-return-details-view [customerReturnDetails]="rmaDetails"
            [trackingOptions]="trackingOptions"></app-return-details-view>
    </div>
    <div *ngIf="displayOverview && overviewModule == transactionNames.ItemReceipt">
        <app-item-receipt-view [rpoDetail]="rpoDetails" [isView]="isView"
            (openScanInfoChild)="showSerialDetails($event,'receipt')" (updateJournalList)="updateJournalList($event)"
            (close)="closeJournalList()"></app-item-receipt-view>
    </div>
    <div *ngIf="displayOverview && overviewModule == transactionNames.Bill">
        <app-bill-view [billDetails]="billDetails" [isView]="isView"
            (openScanInfoChild)="showSerialDetails($event,'bill')" (close)="closeJournalList()"></app-bill-view>
    </div>
    <div *ngIf="displayOverview && overviewModule == transactionNames.BillPayment">
        <app-bill-payment-view [billPayDetails]="billPaymentDetails" [isView]="isView"
            (updateJournalList)="updateJournalList($event)" (close)="closeJournalList()"></app-bill-payment-view>
    </div>
    <app-journal-entry-view *ngIf="displayJournalEntryViewDialog" [accountsTransactionMasterID]="transactionMasterId"
        [allAccounts]="allAccounts" [isView]="isView" [confirmVoid]="confirmVoid" (onSuccessfullAddEdit)="onSuccessfullJournalAdd($event)"
        (isJEVoided)="checkVoidedJE($event)" (onCancelEdit)="onDialogClose($event)">
    </app-journal-entry-view>
    <p-footer style="float: right;margin-top: 20px;" *ngIf="!displayJournalEntryViewDialog">
        <button *ngIf="isShowVoidDelete && allowedOverviewModules.includes(overviewModule)" type="button" pButton label="Void" [disabled]="isVoided" (click)="isVoidDeleteEntry(true)" class="p-mr-2"></button>
        <p-button *ngIf="isShowVoidDelete && allowedOverviewModules.includes(overviewModule)"
        [label]="'Delete'" (click)="isVoidDeleteEntry(false)" styleClass="p-button-danger" class="p-mr-2"></p-button>
        <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>
<!-- edit invoice -->
<div *ngIf="displayInvoicingAdd && overviewModule  == 'Invoice'">
    <app-invoice-add-edit [type]="'EDIT'" [invoicingHeader]="'Edit Invoice'" [selectedInvoicing]="selectedInvoicing"
        [displayInvoicingAdd]="displayInvoicingAdd" (displayInvoiceCreate)="onInvoiceCreateDialogClose($event)"
        (cancel)="onInvoiceDialogCancel($event)" (confirm)="voidInvoice($event)">
    </app-invoice-add-edit>
</div>

@if(displayReturnAdd && overviewModule == transactionNames.VendorRMA){
<div>
    <app-vendor-return-add-edit *ngIf="displayReturnAdd && overviewModule == transactionNames.VendorRMA"
        [type]="returnDialogType" [dialogHeader]="returnDialogHeader" [displayReturnAdd]="displayReturnAdd"
        [trackingOptions]="trackingOptions" [selectedVendorRenurnId]="overviewRefId"
        (onVendorRmaSaveComplete)="onVendorRmaSaveComplete($event)"></app-vendor-return-add-edit>
</div>
}

<!-- Vendor Credit Add/Edit -->
@if(displayVendorCreditAddEditDialog){
    <app-vendor-credit-add-edit 
    [displayVendorCreditAddEditDialog]="displayVendorCreditAddEditDialog"
    [vendorCreditDialogHeader]="vendorCreditDialogHeader" [selectedVendorCreditId]="overviewRefId" [visibleFromModule]="'Finance'"
    [dialogType]="vendorCreditDialogType"  (onDeleteVendorCredit)="onDeleteVendorCredit($event)" (onCloseVendorCreditDialog)="onCloseVendorCreditDialog($event)">
</app-vendor-credit-add-edit>
}

<!-- Receive payments -->
<app-receive-payments *ngIf="displayReceivedPayment" [receivedPaymentId]="selectedInvTransRow?.referenceId" [displayInvoiceReceive]="displayReceivedPayment"
  [channelName]="selectedChannel?.name" [accountChannels]="accountChannels" [selectedInvoicing]="selectedInvoicing"
  [type]="selectedInvTransRow.transactionType  == transactionNames.ReceivePayment ? receivePaymentDialogType.ViewPaymentDetails : receivePaymentDialogType.SinglePayment"
  (invoiceReceiveEventEmitter)="onReceivePaymentsDialogClose($event)">
</app-receive-payments>

<!-- convert Bill to Bill payments -->
<div *ngIf="selectedBillTransRow && isBillPayment">
    <app-addedit-billpay  [billDetails]="selectedBillTransRow" [decimalLength]="fractionDigits"
     (hideDialog)="cancel($event)" (closeDialog)="closeDialog($event)"></app-addedit-billpay>
</div>
<ng-container *ngIf="( closingDate && closingDateModuleName)">
    <app-closing-statement-validation [isClosingDate]="closingDate" 
        [moduleName]="closingDateModuleName" (isClosingStatementDate)="isClosingStatementDate($event)">
    </app-closing-statement-validation>
</ng-container>
<!-- Tracking Information -->
<p-dialog header="Tracking Information" [(visible)]="displayScanInfo" [modal]="true" [responsive]="true"
    [closable]="false" [style]="{ width: '70vw' }" (onHide)="savedOptionSelection=null;">
    <div class="card">
        <div class="p-field p-formgrid p-grid">
            <p-table [value]="nameLists" class="w-100" [lazy]="true" [paginator]="true" [first]="first"
                [totalRecords]="totalTBRecord" [rows]="pageSize" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="rowsPerPageTB" (onPage)="loadSerialsLazy($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th id="lot"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'lotChecked',savedOptionSelection)">
                            {{utilityService.displayName('lotChecked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('lotChecked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('lotChecked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('lotChecked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="revision"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'revisionChecked',savedOptionSelection)">
                            {{utilityService.displayName('revisionChecked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('revisionChecked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('revisionChecked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('revisionChecked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="date"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'expirationChecked',savedOptionSelection)">
                            {{utilityService.displayName('expirationChecked',trackingOptions,'label')}}
                        </th>
                        <th id="serialNo"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serializedChecked',savedOptionSelection)">
                            {{utilityService.displayName('serializedChecked',trackingOptions,'label')}}
                        </th>
                        <th id="serialNo2"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial2Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial2Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial2Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial2Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial2Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo3"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial3Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial3Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial3Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial3Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial3Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo4"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial4Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial4Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial4Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial4Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial4Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo5"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial5Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial5Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial5Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial5Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial5Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo6"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial6Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial6Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial6Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial6Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial6Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo7"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial7Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial7Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial7Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial7Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial7Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo8"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial8Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial8Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial8Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial8Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial8Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo9"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial9Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial9Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial9Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial9Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial9Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo10"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial10Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial10Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial10Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial10Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial10Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo11"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial11Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial11Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial11Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial11Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial11Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo12"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial12Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial12Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial12Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial12Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial12Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo13"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial13Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial13Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial13Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial13Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial13Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo14"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial14Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial14Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial14Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial14Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial14Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo15"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial15Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial15Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial15Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial15Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial15Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo16"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial16Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial16Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial16Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial16Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial16Checked',trackingOptions,'currency')}})</span>
                        </th>
                        <th id="serialNo17"
                            *ngIf="utilityService.showTrackingOption(trackingOptions,'serial17Checked',savedOptionSelection)">
                            {{utilityService.displayName('serial17Checked',trackingOptions,'label')}}
                            <span
                                *ngIf="utilityService.displayName('serial17Checked',trackingOptions,'control')=='Percentage'">(%)</span>
                            <span
                                *ngIf="utilityService.displayName('serial17Checked',trackingOptions,'control')=='Currency'">({{utilityService.displayName('serial17Checked',trackingOptions,'currency')}})</span>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-i="rowIndex">
                    <tr>
                        <td *ngIf="utilService.showTrackingOption(trackingOptions,'lotChecked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('lotChecked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.lotNo }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.lotNo &&
                                    product.lotNo |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'revisionChecked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('revisionChecked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.revisionNo }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.revisionNo &&
                                    product.revisionNo |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'expirationChecked',savedOptionSelection)">
                            {{product.expiration | date: 'MM/dd/yyyy'}}
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serializedChecked',savedOptionSelection)">
                            {{
                            product.serialNo }}</td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial2Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial2Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo2 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo2 &&
                                    product.serialNo2 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial3Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial3Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo3 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo3 &&
                                    product.serialNo3 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial4Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial4Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo4 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo4 &&
                                    product.serialNo4 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial5Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial5Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo5 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo5 &&
                                    product.serialNo5 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial6Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial6Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo6 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo6 &&
                                    product.serialNo6 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial7Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial7Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo7 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo7 &&
                                    product.serialNo7 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial8Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial8Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo8 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo8 &&
                                    product.serialNo8 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial9Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial9Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo9 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo9 &&
                                    product.serialNo9 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial10Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial10Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo10 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo10 &&
                                    product.serialNo10 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial11Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial11Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo11 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo11 &&
                                    product.serialNo11 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial12Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial12Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo12 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo12 &&
                                    product.serialNo12 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial13Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial13Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo13 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo13 &&
                                    product.serialNo13 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial14Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial14Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo14 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo14 &&
                                    product.serialNo14 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial15Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial15Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo15 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo15 &&
                                    product.serialNo15 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial16Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial16Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo16 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo16 &&
                                    product.serialNo16 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilService.showTrackingOption(trackingOptions,'serial17Checked',savedOptionSelection)">
                            <ng-container
                                *ngIf="utilService.displayName('serial17Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo17 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo17 &&
                                    product.serialNo17 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayScanInfo = false" label="Cancel"
            class="p-button-secondary"></button>
    </p-footer>
</p-dialog>
<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
<p-toast position="top-right" [baseZIndex]="1000000"></p-toast>